module.exports = __webpack_public_path__ + "img/non-active-move-icon.ee4cb40a.svg";